import { pathToRegexp, match } from 'path-to-regexp'
import { redirectFromOldUrl } from './redirect-from-old-url'

const templateEmailPatterns = ['/email/template/:id/edit', '/dashboard/email-template/:id/edit']

const isEmailTemplate = () => {
  return templateEmailPatterns.some(pattern =>
    pathToRegexp(pattern, []).exec(window.location.pathname),
  )
}

const getIdFromPath = (uri: string) => {
  const matcher = match<{ id: string | undefined }>(uri)
  const result = matcher(window.location.pathname)
  if (result && typeof result === 'object' && result.params.id) {
    return Number(result.params.id)
  } else {
    return null
  }
}

export const parseUrl = (): { id: number | null; isTemplate: boolean } => {
  if (isEmailTemplate()) {
    const oldId = getIdFromPath('/email/template/:id/edit')
    if (oldId) {
      redirectFromOldUrl({ isTemplate: true, id: oldId })
    }
    return {
      id: getIdFromPath('/dashboard/email-template/:id/edit'),
      isTemplate: true,
    }
  } else {
    const oldId = getIdFromPath('/mailing/:id/edit')
    if (oldId) {
      redirectFromOldUrl({ isTemplate: false, id: oldId })
    }
    return {
      id: getIdFromPath('/dashboard/mailing/:id/edit'),
      isTemplate: false,
    }
  }
}
